import Header from "../Header/Header";
import React from "react";

export default function () {

    return <>
        <Header/>
        <div className="d-flex justify-content-center align-items-center">
            <h1>404 Page Not Found</h1>
        </div>

    </>
}